<template>
    <section id="default-page">
        <div class="container full-width">
            <div class="row">
                <div class="search-result-top">
                    <div class="top">
                        <div class="left">
                            <h2>
                                Users
                            </h2>
                        </div>
                        <div class="right">
                            <a :href="$laravelRoute('users.create')" class="link">Add New User</a>
                            <a :href="$laravelRoute('companies.create')" class="link">Add New Company</a>
                            <a v-if="total > 0"
                               :href="csvLink"
                               target="_blank"
                               class="link"
                            >
                                Export CSV
                            </a>
                        </div>
                    </div>
                    <div class="bottom">
                    <span class="showing">
                        <strong>Showing</strong>
                        <span>{{ from }}</span>-<span>{{ to }}</span> of <span>{{ total }}</span>
                        results
                    </span>
                        <input placeholder="search" v-model="search" @input="filterBy" />
                        <select id="status" name="status" v-model="status_id" @change="filterBy">
                            <option :value="null">Filter status</option>
                            <option :value="status.id" v-for="status in statuses">{{ status.name }}</option>
                        </select>
                        <select id="role" name="role" v-model="role_id" @change="filterBy">
                            <option :value="null">Filter roles</option>
                            <option :value="role.id" v-for="role in user_roles">{{ role.name }}</option>
                        </select>
                        <select id="sales-reps" name="sales_rep" v-model="sales_rep_id" @change="filterBy">
                            <option :value="null">Filter customers by rep</option>
                            <option :value="salesRep.id" v-for="salesRep in salesReps">
                                {{ salesRep.first_name + ' ' + salesRep.last_name + ' (' + salesRep.username + ')'}}
                            </option>
                        </select>
                        <select id="per_page" name="sales_rep" v-model="per_page" @change="filterBy">
                            <option :value="100">100 per page</option>
                            <option :value="500">500 per page</option>
                            <option :value="2000">Show max</option>
                        </select>
                    </div>
                </div>
                <div class="container-table">
                    <b-table
                            class="list-table"
                            responsive=""
                            :sort-by.sync="sort_by"
                            :sort-asc.sync="sort_asc"
                            :fields="fields"
                            :items="users"
                            show-empty
                    >
                        <template v-slot:empty="scope">
                            {{empty_message}}
                        </template>
                        <template v-slot:cell(first_name)="data">
                            <router-link :to="$laravelRoute('users.show', data.item.id, false)">
                                {{ data.item.first_name }} {{ data.item.last_name }} ({{ data.item.username }})
                            </router-link>
                        </template>
                        <template v-slot:cell(company_id)="data">
                            <a v-if="data.item.company && data.item.company.name" :href="$laravelRoute('companies.show', data.item.company_id)">
                                {{ data.item.company.name }}
                            </a>
                        </template>
                        <template v-slot:cell(region)="data">
                            <span v-if="data.item.region && data.item.region.name">
                                {{data.item.region.name}}
                            </span>
                        </template>
                        <template v-slot:cell(bids_count)="data">
                            <router-link v-if="data.item.bids_count" :to="$laravelRoute('user-bid.index', [], false) + `?filter_user_ids=${data.item.id}`">
                                {{ data.item.bids_count }}
                            </router-link>
                            <span v-else>{{data.item.bids_count}}</span>
                        </template>
                        <template v-slot:cell(stock_count)="data">
                            <router-link v-if="data.item.stock_count" :to="$laravelRoute('users.stockList', data.item.id, false)">
                                {{ data.item.stock_count }}
                            </router-link>
                            <span v-else>{{data.item.stock_count}}</span>
                        </template>
                        <template v-slot:cell(recommends_count)="data">
                            <router-link v-if="data.item.recommends_count" :to="$laravelRoute('recommended.index', [], false) + `?user_id=${data.item.id}`">
                                {{ data.item.recommends_count }}
                            </router-link>
                            <span v-else>{{data.item.recommends_count}}</span>
                        </template>
                        <template v-slot:cell(colour)="data">
                            <div v-if="data.item.profile" class="bid-colour" v-bind:style="'background-color: ' + data.item.profile.bid_color">
                                &nbsp;
                            </div>
                        </template>
                        <template v-slot:cell(fees)="data">
                            <template v-if="data.item.pricing_rule_id && defaultPricing">
                                <div v-if="defaultPricing.id === data.item.pricing_rule_id">
                                    Default
                                </div>
                                <div v-else class="text-warning">
                                    Custom
                                </div>
                            </template>
                            <div v-else>
                                Default
                            </div>
                        </template>
                        <template v-slot:cell(assigned_rep)="data">
                            <a v-if="data.item.sales_rep" :href="$laravelRoute('users.show', data.item.sales_rep.id)">
                                {{ data.item.sales_rep.first_name }} {{ data.item.sales_rep.last_name }}
                            </a>
                        </template>
                        <template v-slot:cell(bump_bid)="data">
                            <div v-if="data.item.bump_bid && data.item.bump_bid.ranges
                                    && data.item.bump_bid.ranges.length">
                                {{data.item.bump_bid.ranges[0].fee /1000}}k between
                                {{data.item.bump_bid.ranges[0].price_min}} - {{data.item.bump_bid.ranges[0].price_max}}
                            </div>
                        </template>
                        <template v-slot:cell(settings)="data">
                            <div class="d-flex">
                                <div class="p-2 flex-grow-1">{{data.item.privileges.attended_auctions ? 'A' : '&nbsp;'}}</div>
                                <div class="p-2 flex-grow-1">{{data.item.privileges.show_inspection ? 'I' : '&nbsp;'}}</div>
                                <div class="p-2 flex-grow-1">{{data.item.privileges.show_auction_site ? 'S' : '&nbsp;'}}</div>
                                <div class="p-2 flex-grow-1">{{data.item.privileges.show_lot_number ? 'L' : '&nbsp;'}}</div>
                                <div class="p-2 flex-grow-1">{{data.item.privileges.add_url_logo_image ? 'U' : '&nbsp;'}}</div>
                                <div class="p-2 flex-grow-1">{{data.item.privileges.enable_email ? 'E' : '&nbsp;'}}</div>
                                <div class="p-2 flex-grow-1">{{data.item.privileges.display_auction_result ? 'R' : '&nbsp;'}}</div>
                                <div class="p-2 flex-grow-1">{{data.item.privileges.enable_market_price ? 'M' : '&nbsp;'}}</div>
                                <div class="p-2 flex-grow-1">{{data.item.privileges.enable_auto_notice ? 'N' : '&nbsp;'}}</div>
                            </div>
                        </template>
                        <template v-slot:cell(action)="data">
                            <div>
                                <router-link :to="$laravelRoute('users.edit', data.item.id, false)" class="link">Edit</router-link>
                                <a href="#" @click.prevent="deleteUser(data.item)" class="link">Delete</a>
                                <a v-if="userHasPrivilege('can_login_as')" href="#!" @click.prevent="loginAs(data.item.id)" class="link">login</a>
                            </div>
                        </template>

                    </b-table>
                </div>
                <div class="bottom-table">
                    <b-pagination
                            v-if="total > 0"
                            :total-rows="total"
                            v-model="current_page"
                            :per-page="per_page"
                    ></b-pagination>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    import { mapState, mapMutations } from 'vuex'
    import {objLookup, objToUrl, submitHiddenForm} from '../../util/common'
    import {getterSetter} from '../../util/vuex_setter_getter'
    import _ from 'underscore'
    import LaravelRouter from "../../thirdparty/Ziggy/route";
    import ldb from '../../thirdparty/localdata'
    export default {
        mounted(){
            if (this.$route.query) {
                if (this.$route.query.filter_by_status) {
                    this.status_id = parseInt(this.$route.query.filter_by_status)
                }
                if (this.$route.query.filter_by_sales_rep_id) {
                    this.sales_rep_id = parseInt(this.$route.query.filter_by_sales_rep_id)
                }
                if (this.$route.query.sort_by) {
                    this.sort_by = this.$route.query.sort_by
                }
                if (this.$route.query.sort_asc) {
                    this.sort_asc = this.$route.query.sort_asc
                }
                if (this.$route.query.search) {
                    this.search = this.$route.query.search
                }
                if (this.$route.query.filter_by_role) {
                    this.role_id = parseInt(this.$route.query.filter_by_role)
                }
            }
            if (this.$userIsRole('sales')) {
                this.sales_rep_id = this.loggedInUser.id
            }
            this.filterBy();
            this.$store.dispatch('userRoles/getUserRoles');
            this.$store.dispatch('users/getSalesReps').then((salesReps => {
                this.salesReps = salesReps;
            }));
        },
        data() {
            return {
                default_empty_message: 'There is no users...',
                empty_message: 'There is no users...',
                sort_by: 'company_id',
                sort_asc: true,
                search: null,
                userSearchCancelToken: null,
                page: null,
                fields: [
                    {label: 'clr', key: 'colour', sortable: false},
                    {label: 'Company', key: 'company_id',sortable: false},
                    {label: 'Name', key: 'first_name', sortable: true},
                    {label: 'Stck', key: 'stock_count', sortable: false},
                    {label: 'Bids', key: 'bids_count', sortable: false},
                    {label: 'Rec', key: 'recommends_count', sortable: false},
                    {label: 'Fees', key: 'fees', sortable: false},
                    {label: 'clr', key: 'colour', sortable: false},
                    {label: 'Email', key: 'email', sortable: true},
                    {label: 'Phone', key: 'profile.phone', sortable: false},
                    {label: 'Region', key: 'region', sortable: false},
                    {label: 'Assigned Rep', key: 'assigned_rep', sortable: false},
                    // {label: 'Settings', key: 'settings', sortable: false},
                    // {label: 'Login as user', key: 'canBeLoggedAs', sortable: true},
                    {label: 'Bump', key: 'bump_bid', sortable: false},
                    {label: 'Date', key: 'created_at', sortable: true},
                    {label: 'Action', key: 'action'},
                ],
                salesReps: [],
                status_id: 1,
                role_id: null,
                sales_rep_id: null,
            }
        },
        computed: {
            ...mapState({
                users: state => state.users.all,
                from: state => state.users.from,
                to: state => state.users.to,
                last_page: state => state.users.last_page,
                total: state => state.users.total,
                statuses: state => state.userStatuses.all,
                user_roles: state => state.userRoles.all,
            }),
            per_page: new getterSetter('users/getPerPage', 'users/setPerPage'),
            current_page: {
                get(){
                    return this.$store.getters['users/getCurrentPage'];
                },
                set(value){
                    this.setPage(value)
                    return this.filterBy(value)
                }
            },
            csvLink(){
                let query = this.getDataQuery({
                    page: 1,
                    per_page: 2000,
                    format: 'csv'
                })
                let url = LaravelRouter('users.index', query, true);
                // let url = url_path + '?' + objToUrl(query)
                return url
            },
        },
        methods: {
            ...mapMutations({
                setPage: 'users/setPage'
            }),
            objLookup,
            /* formatAuctionDate(auction){
                return window.moment(auction).format('YYYY/MM/DD')
            }, */
            getDataQuery(params){
                let data = Object.assign({
                    page: 1,
                    sort_by: this.sort_by,
                    sort_asc: this.sort_asc,
                    filter_by_status: this.status_id,
                    filter_by_role: this.role_id,
                    filter_by_sales_rep_id: this.sales_rep_id,
                    searchUser: this.search,
                    include_counts: 1
                }, params);
                return data
            },
            async deleteUser (user) {
                console.log(user)
                try {
                    await this.$confirm('Are you sure you want to delete ' +user.name+ '?')
                } catch (e) {
                    console.log('Delete cancelled')
                    return;
                }
                try {
                    await this.$store.dispatch('users/deleteUser', {
                        id: user.id,
                    })
                    await this.getUsers()
                } catch (e) {
                    console.warn(e)
                }
            },
            async getUsers(){
                if (this.userSearchCancelToken) {
                    this.userSearchCancelToken.cancel('Request cancelled for new request')
                }
                this.userSearchCancelToken = this.axios.CancelToken.source();
                try {
                    return await this.$store.dispatch('users/getUsers', {
                        args: this.getDataQuery(),
                        cancelToken: this.userSearchCancelToken
                    });
                } catch (e) {
                    console.warn('UserListPage/getUsers catch', e)
                }
                return null;
            },
            loginAs(user_id){
                let url = this.$laravelRoute('login-as-customer', user_id);
                window.sessionStorage.clear()
                ldb.clear()
                submitHiddenForm(url);
            },
            async filterBy(){
                this.empty_message = 'Loading...';
                if (this.userSearchCancelToken) {
                    this.userSearchCancelToken.cancel('Request cancelled for new request')
                }
                this.userSearchCancelToken = this.axios.CancelToken.source();
                try{
                    let users = await this.$store.dispatch('users/getUsers', {
                        args: {
                            sort_by: this.sort_by,
                            sort_asc: this.sort_asc,
                            filter_by_status: this.status_id,
                            filter_by_role: this.role_id,
                            filter_by_sales_rep_id: this.sales_rep_id,
                            page: this.current_page,
                            searchUser: this.search
                        },
                        cancelToken: this.userSearchCancelToken
                    });
                    this.replaceState();
                    this.empty_message = this.default_empty_message;
                } catch (e) {
                    this.empty_message = 'There was a problem loading the users.';
                }
            },
            replaceState(){
                let args = {}
                if (this.sort_by !== 'company') {
                    args.sort_by = this.sort_by
                }
                if (this.sort_asc !== true) {
                    args.sort_asc = this.sort_asc
                }
                if (this.search) {
                    args.search = this.search
                }
                if (this.status_id !== 1) {
                    args.filter_by_status = this.status_id
                }
                if (this.sales_rep_id) {
                    args.filter_by_sales_rep_id = this.sales_rep_id
                }
                if (this.role_id !== null) {
                    args.filter_by_role = this.role_id
                }
                let query = objToUrl(args)
                let url = this.$route.path
                if (query) {
                    url = `${url}?${query}`
                }
                if (url !== this.$route.fullPath) {
                    try {
                        this.$nextTick(async () => {
                            await this.$router.replace(url);
                        })
                    } catch (e) {
                        console.warn('error in router.replace', e)
                    }
                }
            },
        }
    }

</script>



// WEBPACK FOOTER //
// resources/js/components/User/UserListPage.vue